
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ServicesHero = () => {
  return (
    <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-28 bg-warm-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center max-w-4xl mx-auto"
        >
          <p className="font-inter text-xs uppercase tracking-widest text-taupe mb-6">
            Comprehensive Solutions
          </p>
          
          <h1 className="font-playfair text-5xl lg:text-7xl font-semibold text-charcoal leading-tight mb-8">
            Services That Drive <br />
            <em className="text-warm-gold">Transformation</em>
          </h1>
          
          <p className="font-inter text-lg text-charcoal/60 max-w-3xl mx-auto mb-10 leading-relaxed">
            From digital strategy to PMO excellence, we deliver comprehensive consulting services designed to elevate your organization's performance and achieve measurable results.
          </p>
          
          <Link
            to="/book-consultation"
            className="inline-flex items-center justify-center bg-warm-gold text-charcoal font-inter font-semibold px-8 py-4 rounded-full hover:bg-soft-bronze transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Discuss Your Needs
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesHero;
